module.exports = __webpack_public_path__ + "static/solvScore-eaeedffd3966d19a3a1952710daa3657.png";